export default "__VITE_ASSET__DmQjLnxT__"